import React, { useEffect, ReactNode } from 'react';
import { Grid } from '@mui/material';

import TextField, { TTextFieldProps } from '@common/components/Form/TextField';

type TFormField = TTextFieldProps & {
	children?: ReactNode;
};

function FormField({ children, ...props }: TFormField) { // @TODO: remove. Use Form/TextField instead

	useEffect(() => {
		console.info('FormField component is DEPRECATED. Use Form/TextField instead');
	}, []);

	return (
		<Grid item>
			<TextField
				{...props}
			/>
			{children}
		</Grid>
	);
}

export default FormField;
